import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from './components/Navbar/Navbar';

import Home from "./pages/Home";
import AboutPage from "./pages/About";
import ServicesPage from "./pages/Services";
import WorkPage from "./pages/Work";
import ContactPage from "./pages/Contact";

import './App.scss';
import AccordionPage from "./pages/Faq";
import TestimonialPage from "./pages/Testimonial";

import Interior from "./pages/Portfolio/Interior";
import Exterior from "./pages/Portfolio/Exterior";
import RevitBim from "./pages/Portfolio/RevitBim";
import ProjectsPage from "./pages/projects";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";

import { Helmet } from "react-helmet-async";



function App() {
  return (
    <>
    <Helmet>
        <title>Architectural Rendering & BIM Services | Gomal Design Studio</title>
        <meta
          name="description"
          content="Professional architectural rendering, Revit & BIM drafting services. High-quality 3D architectural visuals."
        />
      </Helmet>
    <div className="app">
    <Router>
      <Navbar />
      <ScrollToTop/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/work" element={<WorkPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/faqs" element={<AccordionPage/>} />
        <Route path="/testimonials" element={<TestimonialPage/>} />
        <Route path="/projects" element={<ProjectsPage/>} />

        {/* ✅ PORTFOLIO ROUTES */}
          <Route path="/portfolio/interior" element={<Interior />} />
          <Route path="/portfolio/exterior" element={<Exterior />} />
          <Route path="/portfolio/revit-bim" element={<RevitBim />} />
      </Routes>
    </Router>
    </div>
    </>
  );
}

export default App;
